export const logSchema = {
    __schema: {
        queryType: {
            name: 'QUERY_ROOT'
        },
        mutationType: null,
        subscriptionType: null,
        types: [
            {
                kind: 'INTERFACE',
                name: 'LogEvent',
                description: '',
                fields: [
                    {
                        name: 'category',
                        description: 'category',
                        args: [],
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'ENUM',
                                name: 'OutputCategory',
                                ofType: null
                            }
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    },
                    {
                        name: '_type_',
                        description: null,
                        args: [],
                        type: {
                            kind: 'SCALAR',
                            name: 'String',
                            ofType: null
                        },
                        isDeprecated: false,
                        deprecationReason: null
                    }
                ],
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'CampaignListChangeEvent',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'CampaignTimeTargetEvent',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'CampaignRegionsEvent',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'RetargetingMultipliersEvent',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'SingleMultiplierEvent',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'DemographyMultipliersEvent',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'CampaignStatusChangeEvent',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'CampaignNetworkEvent',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'CampaignValueChangeEvent',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'BannersEvent',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'CampaignBroadMatchEvent',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'CampaignRestrictFrequencyEvent',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'AdGroupsRegionsEvent',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'CampaignStrategyEvent',
                        ofType: null
                    }
                ]
            },
            {
                kind: 'UNION',
                name: 'GdCampaignStrategyParam',
                description: '',
                fields: null,
                inputFields: null,
                interfaces: null,
                enumValues: null,
                possibleTypes: [
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyParamAvgCpi',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyParamManual',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyParamAvgCpcPerCamp',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyParamRoi',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyParamWeekBudget',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyParamAvgCpaPerCamp',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyParamAvgCpcPerFilter',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyParamWeekBundle',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyParamAvgCpaPerFilter',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyParamAvgCpa',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyParamAvgClick',
                        ofType: null
                    },
                    {
                        kind: 'OBJECT',
                        name: 'GdCampaignStrategyParamAvgCpm',
                        ofType: null
                    }
                ]
            }
        ],
        directives: [
            {
                name: 'include',
                description:
                    'Directs the executor to include this field or fragment only when the `if` argument is true',
                locations: ['FIELD', 'FRAGMENT_SPREAD', 'INLINE_FRAGMENT'],
                args: [
                    {
                        name: 'if',
                        description: 'Included when true.',
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Boolean',
                                ofType: null
                            }
                        },
                        defaultValue: null
                    }
                ]
            },
            {
                name: 'skip',
                description:
                    "Directs the executor to skip this field or fragment when the `if`'argument is true.",
                locations: ['FIELD', 'FRAGMENT_SPREAD', 'INLINE_FRAGMENT'],
                args: [
                    {
                        name: 'if',
                        description: 'Skipped when true.',
                        type: {
                            kind: 'NON_NULL',
                            name: null,
                            ofType: {
                                kind: 'SCALAR',
                                name: 'Boolean',
                                ofType: null
                            }
                        },
                        defaultValue: null
                    }
                ]
            }
        ]
    }
};
